// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"_3oETMb","mobileLink":"_3E049R","categoryCard":"Gv0g-n","section":"_3L3Xua","category":"_2NJ7qg","iconHolder":"gzExH9"};